import React from 'react';
import { motion } from 'framer-motion';
import FloatingShapes from '../animations/FloatingShapes';

const LoadingSpinner = () => {
  const title = "Genexasource";
  const subtitle = "Connecting talent with opportunity";

  const titleLetters = title.split("");
  const subtitleWords = subtitle.split(" ");

  const titleContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const letterVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const subtitleContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: title.length * 0.05 + 0.5,
      },
    },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-br from-primary-50 to-navy-50 relative overflow-hidden">
      <FloatingShapes />

      <div className="text-center z-10">
        {/* LOGO */}
        <motion.img
          src="/Genexasource-removebg-preview.png"
          alt="Genexasource Logo"
          className="
            w-48 
            sm:w-56 
            md:w-64 
            h-auto 
            mx-auto 
            mb-6 
            object-contain
          "
          initial={{ opacity: 0, scale: 0.6, filter: 'blur(10px)' }}
          animate={{
            opacity: 1,
            scale: 1,
            y: [0, -6, 0],
            filter: 'blur(0px)',
            transition: {
              duration: 1,
              ease: 'easeOut',
              y: {
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut',
              },
            },
          }}
        />

        {/* TITLE */}
        <motion.h2
          className="text-2xl font-bold text-navy-900 mb-2"
          variants={titleContainerVariants}
          initial="hidden"
          animate="visible"
        >
          {titleLetters.map((letter, index) => (
            <motion.span
              key={index}
              variants={letterVariants}
              className="inline-block"
            >
              {letter}
            </motion.span>
          ))}
        </motion.h2>

        {/* SUBTITLE */}
        <motion.p
          className="text-navy-600"
          variants={subtitleContainerVariants}
          initial="hidden"
          animate="visible"
        >
          {subtitleWords.map((word, index) => (
            <motion.span
              key={index}
              variants={wordVariants}
              className="inline-block mr-1"
            >
              {word}
            </motion.span>
          ))}
        </motion.p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
